import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import Form from 'react-bootstrap/Form';
import { ChangeEventHandler, MeasurementInputType } from '../../app/types';

interface MeasurementInputTypeInputProps {
  value: MeasurementInputType;
  onChange?: (v: MeasurementInputType) => void;
};

function MeasurementInputTypeInput(props: MeasurementInputTypeInputProps) {
  const { value, onChange } = props;

  const onTypeChanged: ChangeEventHandler = e => {
    if (onChange) {
      onChange(parseInt(e.target.value));
    }
  };

  const renderHelpText = (value: MeasurementInputType) => {
    switch (value) {
      case MeasurementInputType.EntryInput:
        return (<small className="form-text text-muted">Entries are added daily. Example: Daily weight tracking.</small>);
      case MeasurementInputType.ChecklistInput:
        return (<small className="form-text text-muted">Entries are defined as a checklist to be ticked off. Example: Movies to watch.</small>);
    }
    return;
  }

  return (
    <>
      <Row>
        <Col md={4}>
          <Form.Select value={value} onChange={onTypeChanged}>
            <option value={MeasurementInputType.EntryInput}>Entries</option>
            <option value={MeasurementInputType.ChecklistInput}>Checklist</option>
          </Form.Select>
        </Col>
      </Row>
      <Row>
        <Col>
          {renderHelpText(value)}
        </Col>
      </Row>
    </>
  );
}

export default MeasurementInputTypeInput;